import request from '@/utils/request'

let CategoryaApi = {

  /*全分类列表*/
  list(data) {
    return request._post('/shop/plus.categorya.Index/index', data);
},
getList(data) {
  return request._post('/shop/plus.categorya.Index/getList', data);
},
/*添加全分类*/
add(data) {
    return request._post('/shop/plus.categorya.Index/add', data);
},
/*修改全分类*/
edit(data) {
    return request._post('/shop/plus.categorya.Index/edit', data);
},
/*删除全分类*/
del(data) {
    return request._post('/shop/plus.categorya.Index/del', data);
},
/*全分类详情*/
detail(data) {
  return request._post('/shop/plus.categorya.Index/detail', data);
},

}
export default CategoryaApi;



// WEBPACK FOOTER //
// ./src/api/categorya.js